<mat-form-field style="width: 100%;">
    <mat-label>Bundesländer</mat-label>
    @if (required()) {
      <mat-select required multiple [formControl]="FederalStatesControl" (valueChange)="onChangeEvent($event)" #federal_states>
        @for (federalState of FEDERAL_STATES; track federalState) {
          <mat-option [value]="federalState">{{federalState}}</mat-option>
        }
      </mat-select>
      @if (isEmpty) {
        <mat-error>Bundesländer sind erforderlich</mat-error>
      }
    } @else {
      <mat-select multiple [formControl]="FederalStatesControl" (valueChange)="onChangeEvent($event)" #federal_states>
        @for (federalState of FEDERAL_STATES; track federalState) {
          <mat-option [value]="federalState">{{federalState}}</mat-option>
        }
      </mat-select>
    }
</mat-form-field>